import React, { cloneElement } from 'react';

import styles from './NavItems.module.css';

function MySixtyNavItems({ data, selected, setSelected }) {
    const isSelected = selected === data.value;

    const orginalIconClasses = data?.icon?.props?.className || '';
    const effectiveIconClasses = `${orginalIconClasses} ${isSelected ? 'text-cleanSlate' : 'text-progressBarBlue'}`;

    return (
        <div>
            <button type="button" onClick={() => setSelected(data.value)} className={`flex items-center justify-start mr-0 md:mr-10 pb-2 mb-2 md:mb-0 ${isSelected ? styles.selected : styles.notSelected}`}>
                <div className="mr-1">
                    {data.icon && cloneElement(data.icon, {
                        className: effectiveIconClasses,
                    })}
                </div>
                <p className={`text-[14px] ${isSelected ? 'text-cleanSlate' : 'text-progressBarBlue'} font-medium`}>{data.label}</p>
            </button>
        </div>

    );
}

export default MySixtyNavItems;
